import { ArchetypeDefinition } from '../../archetypeTypes';

export const EXPLORATION_ARCHETYPES: ArchetypeDefinition[] = [
    {
        key: 'explorer',
        name: 'Explorer',
        description: 'Boundary testing and discovery via wavefronts and edges.',
        category: 'Exploration',
        tags: ['novelty', 'search', 'boundaries'],
        weights: { waveIntensity: 0.35, edgeCount: 0.3, nodeCount: 0.2, stability: 0.15 }
    },
    {
        key: 'seeker',
        name: 'Seeker',
        description: 'Curiosity-driven search for new patterns and possibilities.',
        category: 'Exploration',
        tags: ['curiosity', 'search', 'possibility'],
        weights: { edgeCount: 0.35, waveIntensity: 0.25, nodeCount: 0.2, fractalDimension: 0.2 }
    },
    {
        key: 'pioneer',
        name: 'Pioneer',
        description: 'Opening new territory and stabilizing it for growth.',
        category: 'Exploration',
        tags: ['frontier', 'novelty', 'stabilization'],
        weights: { waveIntensity: 0.3, nodeCount: 0.25, stability: 0.25, edgeCount: 0.2 }
    }
];


